module.exports = __webpack_public_path__ + "static/srirachaMike-2c74386deda7658726c3ea8528913365.svg";